module.exports = __webpack_public_path__ + "img/pre_box.d351c473.png";